import { z } from 'zod';
import { LOCALES } from '../../constants';
import { slug } from './helpers';

const contentBase = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1).max(100),
  slug: slug.nullish(),
  content_type_id: z.number().int().positive(),
  locale: z.string().refine((locale) => LOCALES.includes(locale), { message: 'Invalid locale' }),
});

export { contentBase };
